import { theme } from '@aicon-dev/caas-ui/dist/theme.css';
import { VirtualInput } from 'antd-mobile';
import { rgba } from 'polished';
import styled, { css } from 'styled-components';

export const ClearButton = styled.button`
  opacity: 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.5rem;
  height: 1.5rem;
  padding: 0;
  margin: 0;

  color: #cbcbcb;
  font-size: 1.25rem;

  background: none;
  outline: none;
  border: none;

  transition: 250ms ease;

  &:hover {
    color: #b5b5b5;
  }
`;

export const inputWrapStyle = css`
  padding: 0 10px;

  background: white;
  border: 1px solid #d9d9d9;
  border-radius: 6px;

  &:focus,
  &:focus-within {
    border-color: ${theme.color.primary[500]};
    /* box-shadow: ${rgba('#1890FF', 0.1)} 0 0 0 3px; */
    box-shadow: 0 0 0 3px color-mix(in srgb, ${theme.color.primary[500]} 10%, transparent);

    ${ClearButton} {
      opacity: 1;
    }
  }

  &:hover {
    ${ClearButton} {
      opacity: 1;
    }
  }

  &.block {
    width: 100%;
  }
  &.error {
    border-color: #ff6661;
    &:focus,
    &:focus-within {
      border-color: #ff6661;
      box-shadow: ${rgba('#FF6661', 0.1)} 0 0 0 3px;
    }
  }

  transition:
    border 250ms ease,
    box-shadow 250ms ease;
`;

export const inputStyle = css`
  outline: none;
  background: none;

  color: #2c384a;
  font-size: var(--font-size-16, 16px);
  font-weight: 400;
  line-height: 125%;
  letter-spacing: -0.02em;

  &::placeholder {
    color: #bfbfbf;
    font-size: var(--font-size-16, 16px);
    font-weight: 400;
    line-height: 125%;
    letter-spacing: -0.02em;
  }
`;

/**
 * wrapper가 없는 input
 */
export const AllInOneInput = styled.input`
  ${inputWrapStyle}
  ${inputStyle}
  display: inline-block;
  height: 46px;
  background: white;

  &.block {
    display: block;
  }
  &:disabled {
    color: #bfbfbf;
    background-color: #f5f5f5;
  }
`;

/**
 * Input wrapper
 */
export const InputWrapper = styled.span`
  ${inputWrapStyle}
  ${inputStyle}
  display: inline-flex;
  align-items: center;
  height: 46px;
  gap: 2px;
  background: white;

  &.block {
    display: flex;
  }
  &.disabled {
    color: #bfbfbf;
    background-color: #f5f5f5;
  }
`;

/**
 * Input wrapper가 있을 경우 내부 input
 */
export const InnerInput = styled.input`
  ${inputStyle}
  position: relative;
  display: inline-block;
  width: 100%;
  height: 100%;
  min-width: 0;
  padding: 0;

  font-size: inherit;
  border: none;
  border-radius: 0;
  outline: none;
`;

/**
 * textarea styled
 */
export const StyledTextarea = styled.textarea`
  ${inputWrapStyle}
  ${inputStyle}
    overflow: auto;
  display: inline-block;
  resize: none;
  padding: 10px;

  &.block {
    display: block;
  }
`;

export const VirtualInputCustom = styled(VirtualInput)`
  &:disabled {
    color: #bfbfbf;
    background-color: #f5f5f5;
  }

  .adm-virtual-input-placeholder {
    top: 50%;
    transform: translateY(-50%);
  }
`;
